import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon' // svg组件

// register globally
//<svg-icon icon-class="password" />
Vue.component('svg-icon', SvgIcon)

const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('@/assets/svg', false, /\.svg$/)
console.log(req)
requireAll(req)
